import { render, staticRenderFns } from "./OfertaSolicitudCba.vue?vue&type=template&id=23d09142&scoped=true"
import script from "./OfertaSolicitudCba.vue?vue&type=script&lang=js"
export * from "./OfertaSolicitudCba.vue?vue&type=script&lang=js"
import style0 from "./OfertaSolicitudCba.vue?vue&type=style&index=0&id=23d09142&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d09142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d09142')) {
      api.createRecord('23d09142', component.options)
    } else {
      api.reload('23d09142', component.options)
    }
    module.hot.accept("./OfertaSolicitudCba.vue?vue&type=template&id=23d09142&scoped=true", function () {
      api.rerender('23d09142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/Ofertas/solicitud/OfertaSolicitudCba.vue"
export default component.exports